import { render, staticRenderFns } from "./EntranceBanner.vue?vue&type=template&id=4a78b40a"
import script from "./EntranceBanner.vue?vue&type=script&lang=js"
export * from "./EntranceBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports